var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicatorOneWay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 36,
    viewBox: "0 0 16 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 4,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 32,
    r: 3.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 13.1144C7.33341 12.7462 7.63188 12.4478 8.00007 12.4478C8.36826 12.4478 8.66674 12.7462 8.66674 13.1144L8.66674 21L10.357 19.3097C10.6174 19.0493 11.0395 19.0493 11.2998 19.3097C11.5602 19.57 11.5602 19.9921 11.2998 20.2525L8 23.5523L4.70016 20.2525C4.43982 19.9921 4.43981 19.57 4.70016 19.3097C4.96051 19.0493 5.38262 19.0493 5.64297 19.3097L7.33341 21.0001L7.33341 13.1144Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorOneWay);
export default __webpack_public_path__ + "static/media/indicator-one-way.e0b1277e.svg";
export { ForwardRef as ReactComponent };